var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNews = function SvgNews(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.701,
    height: 59.62,
    viewBox: "0 0 31.276 44.715"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#fffbfc",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 4,
    d: "M19.048 2H5.41C3.527 2 2 3.823 2 6.071v32.572c0 2.249 1.527 4.071 3.41 4.071h20.457c1.883 0 3.41-1.823 3.41-4.071V14.214Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 4,
    d: "M17.373 3v11.6h9.105"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 3.5,
    d: "M22.5 23.215h-14M22.5 32.215h-14M11.415 14.25H8.678"
  }))));
};
export default SvgNews;